import Vue from 'vue';

// When the request succeeds
const success = (context, response) => {
  if (response.payment) {
    if (context.booking && context.booking.payments) {
      let payment = context.booking.payments.find(payment => {
        return payment.id === response.payment.id;
      });
      if (payment) {
        payment.paymentStatus = response.payment.status;
        if (payment.invoiceId) {
          payment.status = parseInt(response.payment.status);
        }
      }
    } else {
      let payment = context.payments.find(payment => {
        return payment.id === response.payment.id;
      });
      if (payment) {
        payment.status = parseInt(response.payment.status);
      }
    }
    toastr.success(context.$t("booking.detail.payments.status_updated"));
  }
};

// When the request fails
const failed = (context, error) => {
  context.showToasterError(error);
};

export default (context, payment) => {
    return Vue.$http.post('/bookings/change-payment-status', {payment})
        .then((response) => {
        if (response && response.status === 200) {
            success(context, response.data);
        } else {
            failed(context, response);
        }
}).catch((error) => {
      failed(context, error);
  });
};



// WEBPACK FOOTER //
// ./src/app/services/booking/changePaymentStatus.js